var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWatermarkTablet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 768 1293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_11983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-208.555 1363.49H104.495L391.237 1076.84L678.16 1364H993.381L390.73 761.345L-208.555 1363.49Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.381 -277.493H680.331L393.589 9.15634L106.702 -278H-208.555L394.096 324.655L993.381 -277.493Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204.49 988.63V827.152L917.933 540.322L1205 253.346V94.4746L1047.95 95.1623L602.531 540.828L1047.84 984.286L1204.49 988.63Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-436.493 94.4746V255.989L-149.932 542.819L-437 829.795V988.63L-279.914 987.978L165.469 542.312L-279.842 98.8545L-436.493 94.4746Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_11983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1642,
    height: 1642,
    fill: "white",
    transform: "translate(-437 -278)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermarkTablet);
export default __webpack_public_path__ + "static/media/watermark-tablet.40dd0ba02b03549240660dabd16faf8e.svg";
export { ForwardRef as ReactComponent };